// extracted by mini-css-extract-plugin
module.exports = {"root":"_bb45a6","title":"_284d01","topicContainer":"_fe32f4","grid":"_081df8","index":"_58a2a4","topic":"_3ab6a9"};